import { useMemo } from 'react';

import integration from 'src/lib/api/pagerduty-ui/integration';
import pd from 'src/lib/api/pagerduty-ui/pagerduty';
import { setPagerDutyAccountMetadataForBugsnag } from 'src/lib/bugsnag';
import { usePromise } from 'src/lib/hooks';

import { processSilentOAuth } from './silentOAuth';

let sessionCredentialsPromise = null;

export const useSession = () => {
  const { data = {}, loading, error } = usePromise(() => {
    if (!sessionCredentialsPromise) {
      sessionCredentialsPromise = processSilentOAuth().then(data => {
        configureApiClients(data);
        return data;
      });
      // Error will be handled inside usePromise.
      // Workaround to mute unexpected unhandled promise rejection
      sessionCredentialsPromise.catch(() => {});
    }
    return sessionCredentialsPromise;
  }, []);

  return useMemo(() => ({
    loading,
    loggedIn: !loading && !error,
    accessToken: data.accessToken,
    accountDomain: data.accountDomain,
    environment: data.environment || {},
    error,
  }), [data, loading, error]);
};

const configureApiClients = ({ accessToken, accountDomain, environment: { apiBaseUrl, appBaseUrl, accountBaseUrl } }) => {
  pd.configure({
    accessToken,
    apiBaseUrl,
  });

  integration.configure({
    accessToken,
    apiBaseUrl,
    appBaseUrl,
    accountBaseUrl,
  });

  setPagerDutyAccountMetadataForBugsnag({ accountDomain });
};
